// import { MeshoptDecoder } from "three/examples/jsm/libs/meshopt_decoder.module.js";
import { MeshoptDecoder } from "../utils/MeshoptDecoder";
import { DOMReady } from "../utils/DOMReady";

DOMReady(() => {
    AFRAME.registerSystem("gltf-system", {
        schema: {},
        init() {
            this.ktx2Loader = new THREE.KTX2Loader()
                .setTranscoderPath("libs/basis/")
                .detectSupport(this.el.sceneEl.renderer);
            this.manager = new THREE.LoadingManager();

            this.manager.onStart = function (url, itemsLoaded, itemsTotal) {};
            this.manager.onLoad = () => {
                this.sceneEl.emit("glb-models-loaded");
            };

            this.manager.onProgress = (url, itemsLoaded, itemsTotal) => {
                const progress = (itemsLoaded / itemsTotal) * 100;
                this.sceneEl.emit("glb-loading-progress", {
                    progress: progress,
                });
            };
            this.manager.onError = function (url) {};

            this.gltfLoader = new THREE.GLTFLoader(this.manager);
            this.gltfLoader.setCrossOrigin("anonymous");
            this.gltfLoader.setKTX2Loader(this.ktx2Loader);
            this.gltfLoader.setMeshoptDecoder(MeshoptDecoder);

            // const audioListener = new THREE.AudioListener();
            // this.gltfLoader.register((parser) => new GLTFAudioEmitterExtension(parser, audioListener));
        },
        update() {
            if (this.gltfLoader) {
                return;
            }

            this.ktx2Loader = new THREE.KTX2Loader()
                .setTranscoderPath("libs/basis/")
                .detectSupport(this.el.sceneEl.renderer);
            this.gltfLoader = new THREE.GLTFLoader(this.manager);
            this.qltfLoader.setCrossOrigin("anonymous");
            this.gltfLoader.setKTX2Loader(this.ktx2Loader);
            this.gltfLoader.setMeshoptDecoder(MeshoptDecoder);

            // const audioListener = new THREE.AudioListener();
            // this.gltfLoader.register((parser) => new GLTFAudioEmitterExtension(parser, audioListener));
        },
        getGLTFLoader() {
            return this.gltfLoader;
        },
        getKTX2Loader() {
            return this.ktx2Loader;
        },
    });
});
